(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').toLocaleLowerCase('sv-SE').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function fitTag(brand, model, year) {
    return 'usw-fit-' + brand.slug + '-' + model.slug + '-' + year;
  }

  function modelTag(model) {
    return 'usw-model-' + model.slug;
  }

  function brandTag(brand) {
    return 'usw-brand-' + brand.slug;
  }

  function initFinder(root) {
    if (!root || root.dataset.uswReady === 'true' || !window.USWVehicleData) return;
    root.dataset.uswReady = 'true';

    var brands = window.USWVehicleData.brands || [];
    var contextMode = root.dataset.contextMode || 'brand';
    var contextHandle = root.dataset.contextHandle || root.dataset.brand || '';
    var contextTitle = root.dataset.contextTitle || '';
    var collectionHandle = contextHandle === 'cadillac-bilkladsel' ? 'cadillac' : contextHandle;
    var tags = (root.dataset.currentTags || '').split('|').filter(Boolean);
    var availableTags = (root.dataset.availableTags || '').split('|').map(function (tag) { return tag.trim(); }).filter(Boolean);
    var availableTagSet = new Set(availableTags);
    var selectedFitTag = tags.find(function (tag) { return tag.indexOf('usw-fit-') === 0; }) || '';
    var selectedModelTag = tags.find(function (tag) { return tag.indexOf('usw-model-') === 0; }) || '';
    var selectedBrandTag = tags.find(function (tag) { return tag.indexOf('usw-brand-') === 0; }) || '';
    var brand = null;
    var selectedModel = null;
    var selectedYear = null;

    function findFitSelection(tag) {
      if (!tag) return null;
      for (var brandIndex = 0; brandIndex < brands.length; brandIndex += 1) {
        var fitBrand = brands[brandIndex];
        for (var modelIndex = 0; modelIndex < fitBrand.models.length; modelIndex += 1) {
          var fitModel = fitBrand.models[modelIndex];
          for (var yearIndex = 0; yearIndex < fitModel.years.length; yearIndex += 1) {
            var fitYear = fitModel.years[yearIndex];
            if (fitTag(fitBrand, fitModel, fitYear) === tag) {
              return { brand: fitBrand, model: fitModel, year: fitYear };
            }
          }
        }
      }
      return null;
    }

    var fitSelection = findFitSelection(selectedFitTag);
    if (fitSelection) {
      brand = fitSelection.brand;
      selectedModel = fitSelection.model;
      selectedYear = fitSelection.year;
    } else if (selectedBrandTag) {
      brand = brands.find(function (item) { return brandTag(item) === selectedBrandTag; }) || null;
    } else if (contextMode === 'brand') {
      brand = brands.find(function (item) { return item.collection === collectionHandle || item.slug === collectionHandle; }) || null;
    }

    var brandList = root.querySelector('[data-usw-brand-list]');
    var modelList = root.querySelector('[data-usw-model-list]');
    var yearList = root.querySelector('[data-usw-year-list]');
    var modelSearch = root.querySelector('[data-usw-model-search]');
    var modelEmpty = root.querySelector('[data-usw-model-empty]');
    var selection = root.querySelector('[data-usw-finder-selection]');
    var selectionText = root.querySelector('[data-usw-selection-text]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-usw-step]'));
    var brandStep = root.querySelector('[data-usw-step="brand"]');
    var modelStep = root.querySelector('[data-usw-step="model"]');
    var yearStep = root.querySelector('[data-usw-step="year"]');
    var brandSummary = root.querySelector('[data-usw-brand-summary]');
    var modelSummary = root.querySelector('[data-usw-model-summary]');
    var yearSummary = root.querySelector('[data-usw-year-summary]');

    function openOnly(target) {
      steps.forEach(function (step) { step.open = step === target; });
    }

    function collectionUrl(filterTags, targetBrand) {
      var handle = contextMode === 'category'
        ? contextHandle
        : ((targetBrand || brand) ? (targetBrand || brand).collection : contextHandle);
      var path = '/collections/' + handle;
      return filterTags && filterTags.length ? path + '/' + filterTags.join('+') : path;
    }

    function modelAvailable(model) {
      if (contextMode !== 'category' || !availableTagSet.size || !brand) return true;
      return model.years.some(function (year) { return availableTagSet.has(fitTag(brand, model, year)); });
    }

    function yearAvailable(year) {
      if (contextMode !== 'category' || !availableTagSet.size || !brand || !selectedModel) return true;
      return availableTagSet.has(fitTag(brand, selectedModel, year));
    }

    function setHeading(parts) {
      var heading = document.querySelector('[data-usw-collection-heading]');
      if (!heading) return;
      var vehicleText = parts.join(' ');
      heading.textContent = contextMode === 'category' && contextTitle
        ? contextTitle + ' · ' + vehicleText
        : vehicleText;
    }

    steps.forEach(function (current) {
      current.addEventListener('toggle', function () {
        if (!current.open) return;
        steps.forEach(function (other) {
          if (other !== current) other.open = false;
        });
      });
    });

    function renderBrands() {
      if (!brandList) return;
      brandList.innerHTML = '';
      brands.forEach(function (item) {
        if (contextMode === 'category' && availableTagSet.size && !availableTagSet.has(brandTag(item))) return;
        var link = document.createElement('a');
        link.className = 'usw-finder-choice' + (brand && item.slug === brand.slug ? ' is-active' : '');
        link.href = contextMode === 'category'
          ? collectionUrl([brandTag(item)], item)
          : collectionUrl([], item);
        link.textContent = item.label;
        if (brand && item.slug === brand.slug) link.setAttribute('aria-current', 'page');
        brandList.appendChild(link);
      });
    }

    function renderModels(query) {
      if (!modelList) return;
      modelList.innerHTML = '';
      if (!brand) return;
      var needle = normalize(query);
      var visible = 0;
      brand.models.forEach(function (model) {
        if (!modelAvailable(model)) return;
        if (needle && normalize(model.label).indexOf(needle) === -1) return;
        visible += 1;
        var link = document.createElement('a');
        link.className = 'usw-finder-choice' + (selectedModel && selectedModel.slug === model.slug ? ' is-active' : '');
        link.href = contextMode === 'category'
          ? collectionUrl([brandTag(brand), modelTag(model)])
          : collectionUrl([modelTag(model)]);
        link.textContent = model.label;
        if (selectedModel && selectedModel.slug === model.slug) link.setAttribute('aria-current', 'page');
        modelList.appendChild(link);
      });
      if (modelEmpty) modelEmpty.hidden = visible !== 0;
    }

    function renderYears() {
      if (!yearList) return;
      yearList.innerHTML = '';
      if (!brand || !selectedModel) return;
      var decades = {};
      selectedModel.years.filter(yearAvailable).forEach(function (year) {
        var decade = Math.floor(year / 10) * 10;
        if (!decades[decade]) decades[decade] = [];
        decades[decade].push(year);
      });
      Object.keys(decades).sort().forEach(function (decadeKey, index) {
        var details = document.createElement('details');
        details.className = 'usw-finder-decade';
        var decadeYears = decades[decadeKey];
        if ((selectedYear && decadeYears.indexOf(selectedYear) !== -1) || (!selectedYear && index === 0)) details.open = true;
        var summary = document.createElement('summary');
        summary.textContent = decadeKey + '–' + (Number(decadeKey) + 9);
        var grid = document.createElement('div');
        grid.className = 'usw-finder-year-grid';
        decadeYears.forEach(function (year) {
          var link = document.createElement('a');
          var tag = fitTag(brand, selectedModel, year);
          link.className = 'usw-finder-year' + (selectedYear === year ? ' is-active' : '');
          link.href = collectionUrl([tag]);
          link.textContent = year;
          link.setAttribute('aria-label', brand.label + ' ' + selectedModel.label + ' ' + year);
          grid.appendChild(link);
        });
        details.appendChild(summary);
        details.appendChild(grid);
        yearList.appendChild(details);
      });
    }

    function restoreSelection() {
      if (!brand) return '';
      if (fitSelection) {
        modelSummary.textContent = selectedModel.label;
        yearSummary.textContent = selectedYear;
        if (selection && selectionText) {
          selectionText.textContent = brand.label + ' · ' + selectedModel.label + ' · ' + selectedYear;
          selection.hidden = false;
        }
        setHeading([brand.label, selectedModel.label, selectedYear]);
        return 'fit';
      }
      if (selectedModelTag) {
        var model = brand.models.find(function (item) { return modelTag(item) === selectedModelTag; });
        if (model) {
          selectedModel = model;
          modelSummary.textContent = model.label;
          yearSummary.textContent = 'Välj';
          if (selection && selectionText) {
            selectionText.textContent = brand.label + ' · ' + model.label;
            selection.hidden = false;
          }
          setHeading([brand.label, model.label]);
          return 'model';
        }
      }
      return '';
    }

    renderBrands();
    if (brandSummary) brandSummary.textContent = brand ? brand.label : 'Välj';
    var restored = restoreSelection();
    renderModels('');
    renderYears();
    if (restored === 'fit') openOnly(null);
    else if (restored === 'model') openOnly(yearStep);
    else if (brand) openOnly(modelStep);
    else openOnly(brandStep);

    if (modelSearch) {
      modelSearch.addEventListener('input', function () { renderModels(modelSearch.value); });
    }
    var resetButton = root.querySelector('[data-usw-reset-finder]');
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        window.location.href = contextMode === 'category'
          ? collectionUrl([])
          : (brand ? collectionUrl([], brand) : '/pages/bilmarke');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-usw-vehicle-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
